// @flow

import React from 'react';
import classNames from 'classnames/bind';
import Report from './report';
import style from './style.css';

const cx = classNames.bind(style);

const Actions = () => (
  <div className={cx('disputes-actions')}>
    <div className={cx('disputes-actions__action')}>
      <Report />
    </div>
  </div>
);

export default Actions;
